import { workspaceRegistryItem } from '@/modules/IdentityAndAccess/resourceMemberRegistry/resourceTypes/workspace'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'

/**
 * For convenience, a composable that wraps the resource member tanstack query
 * for the current workspace, passing in the workspace id from context.
 *
 * It provides the same functionality as the resource member tanstack query,
 * but is scoped to the current workspace and doesn't require consumers to
 * pass in the resource id.
 */
export const useWorkspaceMembers = () => {
  const { workspaceId } = useWorkspaceContext()
  return workspaceRegistryItem.useResourceMembers({
    resourceId: workspaceId,
    workspaceId,
  })
}
